export const ORANGE_M = "#F9A220";
export const PRIMARY_GRADIENT = "linear-gradient(to right, #737BFD, #327BD2)";